module.exports = __webpack_public_path__ + "static/img/6702_phase_function_Paper_Points.dff1fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6702_phase_function_Paper_Points.png
// module id = CemD
// module chunks = 0